import React from 'react'
// import { useNavigate } from 'react-router-dom'
import { Auth0Provider } from '@auth0/auth0-react'
import {getConfig} from './config'

const Auth0ProviderWithHistory = ({ children }) => {
    
    
    // const onRedirectCallback = (appState) => {
    //     history.hash(appState?.returnTo || window.location.pathname)
    // }
    const config = getConfig();

    const providerConfig = {
        domain: config.domain,
        clientId: config.clientId,
        ...(config.audience ? { audience: config.audience } : null),
        redirectUri: window.location.origin,
        // onRedirectCallback,
    };

    return(
        <Auth0Provider
            {...providerConfig}
            // onRedirectCallback={onRedirectCallback}
            useRefreshTokens={true}
            cacheLocation="localstorage">
                {children}
        </Auth0Provider>
    )
}

export default Auth0ProviderWithHistory